import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';

// Persistent footer for every public-facing page. Warm palette, no dark mode.
// Certification requirement: About / Privacy Policy / Terms and Conditions / Support.
// Support contact must display support@zitaview.com.
export const SUPPORT_EMAIL = 'support@zitaview.com';

export const PublicFooter = () => (
  <footer
    data-testid={FOOTER.root}
    className="border-t border-zita-taupe/60 bg-transparent"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8">
      <div className="text-xs text-zita-muted flex-1">
        © 2026 Zita — Find Anything. Faster.{' '}
        <span className="text-zita-mocha">
          Part of the <span className="remod-accent font-semibold">RemodWorks</span> AI Ecosystem
        </span>
      </div>
      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
        <Link
          to="/about"
          data-testid={FOOTER.about}
          className="text-zita-mocha hover:text-zita-cocoa transition-colors"
        >
          About
        </Link>
        <Link
          to="/privacy"
          data-testid={FOOTER.privacy}
          className="text-zita-mocha hover:text-zita-cocoa transition-colors"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms"
          data-testid={FOOTER.terms}
          className="text-zita-mocha hover:text-zita-cocoa transition-colors"
        >
          Terms and Conditions
        </Link>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid={FOOTER.support}
          className="text-zita-mocha hover:text-zita-cocoa transition-colors"
        >
          Support · {SUPPORT_EMAIL}
        </a>
      </nav>
    </div>
  </footer>
);

export default PublicFooter;
